var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2Way(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    d: "M26.7437 4.08594C27.9859 4.08594 28.9912 4.98874 28.9912 6.09217L29 18.1276C29 19.2361 27.9893 20.1358 26.7415 20.1358H24.4852V24.1483L19.9682 20.1358H8.67582C7.43365 20.1358 6.41734 19.233 6.41734 18.1296V6.09217C6.41734 4.98874 7.43365 4.08594 8.67582 4.08594H26.7437Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#673ab7",
    d: "M3.25628 1C2.01411 1 1.00882 1.90281 1.00882 3.00624L1 15.0417C1 16.1501 2.01067 17.0499 3.25849 17.0499H5.51477V21.0624L10.0317 17.0499H21.3242C22.5663 17.0499 23.5826 16.1471 23.5826 15.0437V3.00624C23.5826 1.90281 22.5663 1 21.3242 1H3.25628ZM6.64401 6.01559H14.5487V8.12959L17.9364 6.01559V12.0343L14.5487 9.92031V12.0343H6.64401V6.01559Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Way);
export default __webpack_public_path__ + "static/media/2way.28e443d57a62641858c553e83f655311.svg";
export { ForwardRef as ReactComponent };